export default __webpack_public_path__ + "static/media/follow.b09af507.svg";